enum ButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export default ButtonVariant;
